<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M9 3h6a1 1 0 0 1 1 1v1H8V4a1 1 0 0 1 1-1z" />
    <path d="M19 12V6a1 1 0 0 0-1-1h-2M8 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h6" />
    <circle cx="16" cy="16" r="3.5" />
    <path d="m18.475 18.475 2.525 2.525" />
  </svg>
</template>

<script>
export default {}
</script>
